<template>
    <div>
			<div class="loading-block my-3 px-3">
					<div class="text-center light-gray">{{ $t('loading.message') }}</div>
					<div class="loader text-center">
						<div class="spinner-border text-primary" role="status">
							<span class="visually-hidden"></span>
						</div>
					</div>
				</div>
    </div>
</template>